import React, { useContext, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { AppStateContext } from '../AppStateContext';

import Logo from '../media/yesimalkanlogo.svg'

import { Flag } from 'semantic-ui-react'
import { Dropdown } from 'semantic-ui-react'

import { AiFillInstagram, AiFillMail, AiFillPhone, AiOutlineMenu, AiOutlineClose } from 'react-icons/ai'
import { ImLocation } from 'react-icons/im'

// COMPONENT
import PrimaryButton from './button/PrimaryButton';
import SecondButton from './button/SecondButton';

const Navbar = () => {

    const navigate = useNavigate();

    const { language, setLanguage } = useContext(AppStateContext);
    const [nav, setNav] = useState(false);
    const [section, setSection] = useState(0)

    const handleMenuToggle = () => {
        setNav((prevState) => !prevState);
    };

    const handleLanguageChange = (e) => {
        setLanguage(e);
        localStorage.setItem('selectedLanguage', e); // Seçilen dili localStorage'a kaydet
    };

    useEffect(() => {
        // Scroll olay dinleyicisini ekleyin
        const handleScroll = () => {
            const position = window.scrollY; // Geçerli kaydırma pozisyonunu al

            // Scroll Y değerine göre section'ı güncelle
            if (position === 0) {
                setSection(0);
            } else if (position > 0) {
                setSection(1);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Bileşen sona erdiğinde olay dinleyiciyi kaldırın
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        // Sayfa yüklendiğinde localStorage'da kaydedilmiş dili uygula
        const storedLanguage = localStorage.getItem('selectedLanguage');
        if (storedLanguage) {
            setLanguage(storedLanguage);
        }
    }, []);

    const handleNavigation = (path) => {
        window.scrollTo(0, 0);
        navigate(path);
    }

    const openLink = (url) => {
        window.open(
            url,
            '_blank'
        );
    }

    const handleMailSend = () => {
        const emailAddress = 'info@dtyesimalkan.com';
        window.location.href = `mailto:${emailAddress}`;
        console.log('HandleMailSend')
    }

    const handlePhoneCall = () => {
        const phoneNumber = '+90 533 353 64 06';
        window.location.href = `tel:${phoneNumber}`;
    };

    const translations = {
        tr: {
            home: 'Ana Sayfa',
            about: 'Hakkımızda',
            treatments: 'Tedaviler',
            blog: 'Blog',
            contact: 'İletişim',
            ask: 'Sorun'
        },
        en: {
            home: 'Home',
            about: 'About',
            treatments: 'Treatments',
            blog: 'Blog',
            contact: 'Contact',
            ask: 'Ask'
        },
        it: {
            home: 'Pagina Principale',
            about: 'Chi Siamo',
            treatments: 'Trattamenti',
            blog: 'Blog',
            contact: 'Contatti',
            ask: 'Domanda'
        },
    };

    const getText = (key) => {
        return translations[language][key] // Default to the provided key if translation is not found
    };

    const [isOpen, setIsOpen] = useState(false);

    const languages = [
        { code: 'en', flag: 'us', label: 'English' },
        { code: 'tr', flag: 'tr', label: 'Türkçe' },
        { code: 'it', flag: 'it', label: 'Italiano' },
    ];

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const selectLanguage = (selectedLanguage) => {
        handleLanguageChange(selectedLanguage);
        setIsOpen(false);
    };

    const selectedLanguageInfo = languages.find((lang) => lang.code === language);
    return (
        <div className={`flex flex-col fixed top-0 w-full border-b-2 border-slate-200 bg-white z-50 duration-500 ${section === 0 ? 'h-[120px]' : 'h-[80px]'} `}>
            {/* UPPER NAV */}
            <div className={` ${section === 0 ? 'h-10' : 'h-0 opacity-0'} w-full border-t-2 border-b-2 border-slate-200 m-auto duration-500`}>
                <div className='max-w-screen-xl w-full h-full m-auto flex flex-row items-center text-sm text-slate-600 pr-2'>
                    <div className='text-end px-2 border-r-2 border-teal-500 hidden lg:block'>info@dtyesimalkan.com</div>
                    <div className='flex flex-row justify-between w-full'>
                        <div className='text-start px-2 hidden lg:block'>+90 533 353 64 06</div>
                        <div className='flex flex-row items-center m-auto lg:m-0 gap-3 text-[#6DA5C0]'>
                            <AiFillPhone onClick={handlePhoneCall} size={16} className='cursor-pointer' />
                            <ImLocation onClick={() => openLink('https://goo.gl/maps/ZEinpNRcKtNM74GA7')} size={16} className='cursor-pointer' />
                            <AiFillMail onClick={handleMailSend} size={16} className='cursor-pointer' />
                            <AiFillInstagram onClick={() => openLink('https://www.instagram.com/dishekimi_yesim_alkan/')} size={16} className='cursor-pointer' />
                        </div>
                    </div>
                </div>
            </div>
            {/* NAV */}
            <div className='flex flex-row max-w-screen-xl w-full m-auto h-24 px-2 justify-center lg:justify-between items-center'>
                <a href='/'><div style={{ fontFamily: 'Righteous' }} className='text-3xl md:text-4xl cursor-pointer text-[#0F969C]'>Dt. Yeşim Alkan</div></a>
                <div className='hidden lg:flex flex-row items-center gap-10'>
                    <a href='/' ><div className='cursor-pointer'>{getText('home')}</div></a>
                    <a href='/about'> <div className='cursor-pointer'>{getText('about')}</div></a>
                    <a href='/treatments' ><div className='cursor-pointer'>{getText('treatments')}</div></a>
                    {/* <div className='cursor-pointer'>{getText('blog')}</div> */}
                    <a href='/contact'><div className='cursor-pointer'>{getText('contact')}</div></a>
                    <div onClick={() => openLink('https://api.whatsapp.com/send?phone=905333536406')} >
                        <SecondButton text={getText('ask')} />
                    </div>
                </div>

                <div className="relative hidden lg:inline-block">
                    <button
                        onClick={toggleDropdown}
                        className="bg-transparent border border-gray-300 rounded p-1 focus:outline-none"
                    >
                        <Flag name={selectedLanguageInfo.flag} /> {selectedLanguageInfo.label}
                    </button>
                    {isOpen && (
                        <div className="absolute top-10 right-0 w-32 bg-white border border-gray-300 rounded shadow-md">
                            {languages.map((lang) => (
                                <div
                                    key={lang.code}
                                    onClick={() => selectLanguage(lang.code)}
                                    className={`flex items-center p-2 hover:bg-gray-100 cursor-pointer ${language === lang.code ? 'font-semibold' : ''}`}
                                >
                                    <Flag name={lang.flag} /> {lang.label}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <div onClick={handleMenuToggle} className='absolute lg:hidden right-5 cursor-pointer'>
                    <AiOutlineMenu size={25} />
                </div>
            </div>
            <div
                className={`fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${nav ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                    }`}
            >
                <div className="bg-white flex flex-col p-4 rounded-lg gap-2 w-96 text-center">
                    <div className='flex flex-row justify-between'>
                        <div className="relative inline-block">
                            <button
                                onClick={toggleDropdown}
                                className="bg-transparent border border-gray-300 rounded p-1 focus:outline-none"
                            >
                                <Flag name={selectedLanguageInfo.flag} /> {selectedLanguageInfo.label}
                            </button>
                            {isOpen && (
                                <div className="absolute top-10 right-0 w-32 bg-white border border-gray-300 rounded shadow-md">
                                    {languages.map((lang) => (
                                        <div
                                            key={lang.code}
                                            onClick={() => selectLanguage(lang.code)}
                                            className={`flex items-center p-2 hover:bg-gray-100 cursor-pointer ${language === lang.code ? 'font-semibold' : ''}`}
                                        >
                                            <Flag name={lang.flag} /> {lang.label}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <AiOutlineClose size={25} className='self-end cursor-pointer' onClick={handleMenuToggle} />
                    </div>
                    <div onClick={() => handleNavigation('/')} className='cursor-pointer'>{getText('home')}</div>
                    <div onClick={() => handleNavigation('/about')} className='cursor-pointer'>{getText('about')}</div>
                    <div onClick={() => handleNavigation('/treatments')} className='cursor-pointer'>{getText('treatments')}</div>
                    <div onClick={() => handleNavigation('/contact')} className='cursor-pointer'>{getText('contact')}</div>
                    <div onClick={() => openLink('https://api.whatsapp.com/send?phone=905333536406')} >
                        <SecondButton text={getText('ask')} />
                    </div>
                    <div className='flex flex-row items-center m-auto lg:m-0 gap-5 text-[#6DA5C0] pt-2'>
                        <AiFillPhone onClick={() => handlePhoneCall()} size={20} className='cursor-pointer' />
                        <ImLocation onClick={() => openLink('https://goo.gl/maps/ZEinpNRcKtNM74GA7')} size={20} className='cursor-pointer' />
                        <AiFillMail onClick={() => handleMailSend()} size={20} className='cursor-pointer' />
                        <AiFillInstagram onClick={() => openLink('https://www.instagram.com/dishekimi_yesim_alkan/')} size={20} className='cursor-pointer' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar